"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.82 5.368h.556l.084-3.092h-.73l.09 3.092Zm.618 1.203h-.674v-.652h.674v.652Zm.398-5.494 3.178 5.357a.861.861 0 0 1-.741 1.3H7.917a.862.862 0 0 1-.741-1.3l3.178-5.357a.861.861 0 0 1 1.482 0ZM4.665 5.003 0 15.348v.1h.956L5.668 5l-1.003.003Zm2.744 5.982h.913V8.74H7.41v2.245Zm7.538 4.464L11.73 8.52h1.007l3.218 6.93h-1.007Zm-7.538-.038h.913v-2.246H7.41v2.246Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.258 7.856h.835l.126-4.64h-1.096l.135 4.64Zm.928 1.804h-1.012v-.978h1.012v.978Zm.597-8.24 4.767 8.035c.51.86-.11 1.951-1.112 1.951h-9.534a1.292 1.292 0 0 1-1.11-1.951l4.766-8.036a1.292 1.292 0 0 1 2.223 0ZM7.026 7.308 0 22.889v.09h1.462L8.53 7.303l-1.504.005Zm4.116 8.973h1.37v-3.37h-1.37v3.37Zm11.309 6.696-4.829-10.394h1.51l4.828 10.394h-1.51Zm-11.309-.057h1.37v-3.37h-1.37v3.37Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M21.677 10.474h1.113l.169-6.185h-1.461l.179 6.185Zm1.237 2.406h-1.349v-1.304h1.349v1.304Zm.796-10.988 6.356 10.714c.681 1.148-.147 2.602-1.482 2.602H15.872c-1.335 0-2.163-1.454-1.481-2.602l6.356-10.714a1.723 1.723 0 0 1 2.963 0ZM9.368 9.745 0 30.52v.118h1.95l9.424-20.9-2.006.007Zm5.488 11.964h1.826v-4.492h-1.826v4.492Zm15.078 8.928L23.496 16.78h2.013l6.437 13.858h-2.012Zm-15.078-.076h1.826v-4.492h-1.826v4.492Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.818 15.79h1.711l.26-9.509h-2.247l.276 9.509Zm1.9 3.698h-2.073v-2.005h2.074v2.005Zm1.225-16.893 9.772 16.472c1.047 1.766-.225 4-2.278 4H23.893c-2.052 0-3.325-2.234-2.278-4l9.772-16.472c1.026-1.73 3.53-1.73 4.556 0Zm-21.8 12.457L.004 46.404H2.24l14.14-31.359-2.239.007Zm8.571 17.626h2.04V26.54h-2.04v6.138Zm23.043 13.726-9.54-20.537h2.248L48 46.396v.008h-2.243Zm-23.043-.116h2.04V40.15h-2.04v6.138Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M43.757 21.053h2.281l.346-12.678h-2.996l.37 12.678Zm2.534 4.931h-2.765v-2.673h2.765v2.673ZM47.923 3.46l13.03 21.963c1.396 2.354-.3 5.333-3.038 5.333H31.857c-2.737 0-4.434-2.979-3.038-5.333L41.85 3.46c1.368-2.306 4.706-2.306 6.074 0ZM18.856 20.07.006 61.871h2.982L21.842 20.06l-2.986.01Zm11.429 23.5h2.719v-8.184h-2.719v8.184Zm30.724 18.301-12.72-27.383h2.997L64 61.861v.011h-2.991Zm-30.724-.155h2.719v-8.184h-2.719v8.184Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconLaneDepartureWarning = function IconLaneDepartureWarning(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Lane Departure Warning' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "LaneDepartureWarning"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconLaneDepartureWarning.sizes = [16, 24, 32, 48, 64];
IconLaneDepartureWarning.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconLaneDepartureWarning;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/auto/LaneDepartureWarning.js
// module id = 1927
// module chunks = 0